import React from 'react';
import type { AssignmentDetail, AssignmentShift } from '../../../../../js/api';
import { ShiftResponseForm } from './ShiftResponseForm';

export const ShiftsTab: React.FC<{
  shifts: AssignmentShift[];
  assignment?: AssignmentDetail;
  onResponseSuccess?: () => void;
  onDirtyChange?: (hasDirty: boolean) => void;
  isLockedOut?: boolean;
}> = ({ shifts, assignment, onResponseSuccess, onDirtyChange, isLockedOut = false }) => {
  if (!shifts || shifts.length === 0) {
    return <div className="tw:text-center tw:text-zinc-500 tw:py-8">No shifts scheduled</div>;
  }

  if (!assignment) {
    return <div className="tw:text-center tw:text-zinc-500 tw:py-8">Loading...</div>;
  }

  return (
    <ShiftResponseForm
      assignment={assignment}
      onSuccess={onResponseSuccess ?? (() => {})}
      onDirtyChange={onDirtyChange}
      isLockedOut={isLockedOut}
    />
  );
};
